import { render, staticRenderFns } from "./CropCard.vue?vue&type=template&id=dc8d77b2&scoped=true&"
import script from "./CropCard.vue?vue&type=script&lang=js&"
export * from "./CropCard.vue?vue&type=script&lang=js&"
import style0 from "./CropCard.vue?vue&type=style&index=0&id=dc8d77b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8d77b2",
  null
  
)

export default component.exports